import React from 'react';
import { Button } from '../ui/button';
import Icon from '../ui/icon';
import { cn } from '../../lib/utils';
import { useScrollDirection } from '../../hooks/useScrollDirection';

interface NavItem {
  id: string;
  label: string;
  icon: string;
  href: string;
  badge?: number;
}

interface BottomNavProps {
  items: NavItem[];
  activeItem?: string;
  onItemClick?: (item: NavItem) => void;
  className?: string;
}

const BottomNav: React.FC<BottomNavProps> = ({
  items,
  activeItem,
  onItemClick,
  className
}) => {
  const { scrollDirection, isScrolling } = useScrollDirection();
  
  return (
    <nav className={cn(
      "fixed bottom-0 left-0 right-0 z-50 border-t bg-background transition-transform duration-300 ease-in-out",
      scrollDirection === 'down' && isScrolling ? 'translate-y-full' : 'translate-y-0',
      className
    )}>
      <div className="max-w-4xl mx-auto px-4 flex items-center justify-around p-4">
        {items.map((item) => (
          <Button
            key={item.id}
            variant={activeItem === item.id ? "default" : "ghost"}
            size="icon"
            className={cn(
              "flex items-center gap-2 rounded-lg",
              // Mobile: icon only, Desktop: icon + text
              "h-12 w-12 md:h-auto md:w-auto md:px-3 md:py-2",
              activeItem === item.id 
                ? "bg-primary text-primary-foreground" 
                : "text-muted-foreground hover:text-foreground"
            )}
            onClick={() => onItemClick?.(item)}
          >
            <div className="relative">
              <Icon name={item.icon} size={24} />
            </div>
            {/* Show text on desktop only */}
            <span className="hidden md:block text-sm">{item.label}</span>
          </Button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
